import * as React from "react";
import { useHistory } from "react-router";

import {
  ServiceTutelleApi,
  FcbServiceTutelleGridDto,
  ServiceTutelleSearch,
  EBooleanSearchTypes
} from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { EditButton, SearchTablePage, ViewButton } from "../../../../../components";
import { useTl } from "../../../../../hooks";
import { useAbortableApiServiceFactory, useApiService } from "../../../../../hooks/useApiService";
import { ETLCodes } from "../../../../../locales";
import styled from "styled-components";

interface IServiceTutelleListPageProps {}

const Container = styled.div`
  display: flex;
`;

export const ServiceTutelleListPage: React.FunctionComponent<IServiceTutelleListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(ServiceTutelleApi);

  const columns = React.useMemo(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: FcbServiceTutelleGridDto) => (
          <Container>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.serviceTutelle}/${row.idserviceTutelle}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.serviceTutelle}/${row.idserviceTutelle}/detail/edit`)}
            />
          </Container>
        )
      },
      {
        header: () => t(ETLCodes.Code),
        fieldName: "code",
        autoFitContent: true
      },
      {
        header: () => t(ETLCodes.Service),
        fieldName: "nom"
      },
      {
        header: () => t(ETLCodes.Adresse),
        fieldName: "adresse"
      },
      {
        header: () => t(ETLCodes.CodePostal),
        fieldName: "codePostal",
        autoFitContent: true
      },
      {
        header: () => t(ETLCodes.Localite),
        fieldName: "localite"
      },
      {
        header: () => t(ETLCodes.Tel),
        fieldName: "telephone"
      },
      {
        header: () => t(ETLCodes.Fax),
        fieldName: "fax"
      }
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.serviceTutelle}/0/detail/edit`);
  }, [history]);

  const getCriteriasFn = React.useCallback(() => api.serviceTutelleGetSearchCriterias({ includeListsValues: true }), [
    api
  ]);

  const apiFactory = useAbortableApiServiceFactory(ServiceTutelleApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFn = React.useCallback(
    (nextSearch?: ServiceTutelleSearch) => {
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.serviceTutelleBaseSearch({ ServiceTutelleSearch: nextSearch });
    },
    [apiFactory]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={getCriteriasFn}
      searchFunction={searchFn}
      onAbort={onAbort}
      addFunc={addItemFunction}
      breadCrumbs={[{ text: t(ETLCodes.ServicesAlternance), route: ERoutes.serviceTutelle }]}
      sortKeys={{ nom: "ASC" }}
      defaultCriterias={[
        {
          criteria: "Actif",
          searchMode: EBooleanSearchTypes.Equals,
          value: true
        }
      ]}
    />
  );
};
